var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10655 4.58655C7.84624 1.59224 4.72245 0.123027 4.59025 0.0630588C4.46666 0.00496309 4.32817 -0.0135984 4.19364 0.00990541C0.587391 0.608222 0.0449534 2.7071 0.0231469 2.79433C-0.00652183 2.91588 -0.00180302 3.04329 0.0367759 3.16231C4.33811 16.5079 13.2774 18.9816 16.2159 19.7952C16.4421 19.8579 16.6288 19.9084 16.7706 19.9547C16.9323 20.0075 17.108 19.9973 17.2626 19.9261C17.3525 19.8852 19.4759 18.8848 19.9952 15.622C20.0182 15.4796 19.9953 15.3335 19.9298 15.205C19.8834 15.115 18.7727 13.0011 15.6925 12.2543C15.588 12.2275 15.4786 12.2266 15.3736 12.2515C15.2687 12.2765 15.1714 12.3265 15.0901 12.3974C14.1183 13.2274 12.7759 14.1119 12.1966 14.2032C8.31371 12.3047 6.14533 8.66164 6.06355 7.97065C6.01585 7.58222 6.90583 6.21795 7.92937 5.10854C7.99371 5.03872 8.04271 4.9562 8.07322 4.8663C8.10374 4.7764 8.11509 4.6811 8.10655 4.58655Z",
    fill: "#2E3192"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.cd271ffb84247085afb8314a9f6a290a.svg";
export { ForwardRef as ReactComponent };